export const contentTableConfig = {
  title: '小程序相关',
  propList: [
    {prop: 'type', label: '类型', minWidth: '60', slotName: 'type'},
    {prop: 'name', label: '名称', minWidth: '60'},
    {prop: 'cstatus', label: '状态', minWidth: '60', slotName: 'cstatus'},
    {prop: 'manager', label: '管理员', minWidth: '60'},
    {prop: 'originalId', label: '原始ID', minWidth: '50'},
    {prop: 'remark', label: '备注', minWidth: '60'},
    {
      label: '操作',
      minWidth: '60',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
